import { useState } from 'react';
import { collection, doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

function Signup() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState(''); // To control the message in the modal

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!email) {
      alert('Please enter a valid email.');
      return;
    }

    setIsSubmitting(true);
    setShowModal(true); // Show modal immediately on submit
    setModalMessage('Submitting...'); // Set modal message to "Submitting..."

    const docRef = doc(collection(db, 'signup'), email.trim());

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setModalMessage('This email is already registered.');
      } else {
        await setDoc(docRef, { email, verified: false });
        setModalMessage('Check your email for a verification link!');
      }
    } catch (error) {
      console.error('Error during signup:', error);
      setModalMessage('Error occurred. Try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const dismissModal = () => {
    setShowModal(false);
    setEmail(''); // Optionally clear email after dismissal
  };

  return (
    <div className="signup-container">
      <form onSubmit={handleSignup} className="signup-form">
        <input
          id="email"
          type="email"
          autocomplete="on"
          placeholder="Get notified when Shepard's Tone begins"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isSubmitting}
          className="signup-input"
        />
        <button type="submit" disabled={isSubmitting} className="signup-button">
          {isSubmitting ? 'Submitting...' : 'Sign Up'}
        </button>
      </form>

      {/* Modal overlay */}
      {showModal && (
        <div className="blur-overlay">
          <div className="modal-message">
            <p>{modalMessage}</p>
            {!isSubmitting && ( // Only show dismiss button when not submitting
              <button className="dismiss-button" onClick={dismissModal}>
                Okay
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Signup;
